import { Box, Typography } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  wrap: {
    display: "flex",
    alignItems: "center",
    padding: "20px",
    marginTop: "40px",
    gap: "40px",
    backgroundColor: (theme) => theme.palette.blue.c20,
    width: "700px",
    height: "80px",
    borderRadius: "8px",
    boxSizing: "content-box"
  },
  boxBorder: {
    borderRight: (theme) => `1px solid ${theme.palette.blue.c20}`,
    display: "flex",
    alignItems: "center",
    gap: "20px"
  },

  wraperText: {
    color: "#0A78CD",
    textTransform: "uppercase"
  },
  score: {
    backgroundColor: "#F2F8FC",
    color: "#0A78CD",
    borderRadius: "80px",
    height: "80px",
    width: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  button: {
    padding: 0,
    "&:disabled": {
      color: "darkBlue.c50"
    }
  },
  message: (theme) => {
    return {
      ...theme.typography.body2,
     }
  }
};

export function MatchConfidanceScore({ markaazConfidenceScore, onEditThreshold }) {
  const showRecommendedMsg = markaazConfidenceScore < 8.3;
  const disabled = true;

  return (
    <Box sx={sx.wrap}>
      <Box sx={sx.boxBorder}>
        <Box sx={sx.score}>
          <Typography variant="h4">{markaazConfidenceScore}</Typography>
        </Box>
        <Box sx={{ width: "111px" }}>
          <Typography variant="overline2" sx={sx.wraperText}>
            Markaaz Match Confidence Threshold
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography sx={sx.message} color="darkBlue.c100" width="460px">
          Your current Markaaz Match Confidence Threshold is set to &nbsp;
          <Typography variant="body2B">{markaazConfidenceScore}</Typography>. Any match scores below this value will
          result in a No Match Found message.
          {showRecommendedMsg && (
            <>
              This value differs from the recommended Markaaz Match Confidence Threshold of &nbsp;
              <Typography variant="body2B">8.3</Typography>. &nbsp;
              <MzButton onClick={onEditThreshold} disabled={!disabled} sx={sx.button}>
                Edit Threshold (Admin Only)
              </MzButton>
            </>
          )}
        </Typography>
      </Box>
    </Box>
  );
}
